import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  GlobalStyles,
  StyledContainer,
  StyledPage
} from './OutOfOfficeComponent.styled';
import OutOfOfficeArchive from './sections/archive/OutOfOfficeArchive';
import Footer from './sections/footer/Footer';
import OutOfOfficeForm from './sections/form/OutOfOfficeForm';
import OutOfOfficeHeader from './sections/header/OutOfOfficeHeader';

const OutOfOfficeComponent: React.FC = () => {
  const { t } = useI18n('out-of-office');

  return (
    <>
      <GlobalStyles />
      <StyledPage>
        <img
          src={getPublicPath('/images/outOfOffice/banner.svg')}
          alt={t('out-of-office.header.banner')}
          className="desktop"
        />
        <img
          src={getPublicPath('/images/outOfOffice/banner_mobile.svg')}
          alt={t('out-of-office.header.banner')}
          className="mobile"
        />
        <StyledContainer>
          <OutOfOfficeHeader />
          <OutOfOfficeForm />
          <OutOfOfficeArchive />
        </StyledContainer>
        <Footer />
      </StyledPage>
    </>
  );
};

export default OutOfOfficeComponent;
